import {
  CAT_RUNNING_CHURU_DESPAWN_MARGIN,
  CAT_RUNNING_MAGNET_PULL_SPEED,
  CAT_RUNNING_MAGNET_RADIUS,
} from '../../constants'
import { getPlayerHitbox, getChuruHitbox, isRectOverlap } from '../collision'
import { updateChuruSpawner } from '../spawners/churus'

const getChuruFloatOffset = (floatTime) => Math.sin(floatTime) * 5

export const updateChuruPositions = (world, deltaSec) => {
  world.churus.forEach((churu) => {
    churu.previousX = churu.x
    churu.previousY = churu.y
    churu.previousFloatTime = churu.floatTime
    churu.x -= world.speed * deltaSec
    churu.floatTime += deltaSec * 2.5
  })
}

export const cleanupChurus = (world) => {
  world.churus = world.churus.filter(
    (churu) => churu.x + churu.width >= -CAT_RUNNING_CHURU_DESPAWN_MARGIN,
  )
}

export const applyMagnetToChurus = (world, deltaSec) => {
  if (world.magnetMs <= 0) return

  const playerHitbox = getPlayerHitbox(world.player)
  const playerCenterX = playerHitbox.x + playerHitbox.width / 2
  const playerCenterY = playerHitbox.y + playerHitbox.height / 2

  world.churus.forEach((churu) => {
    const floatOffsetY = getChuruFloatOffset(churu.floatTime)
    const churuCenterX = churu.x + churu.width / 2
    const churuCenterY = churu.y - churu.height / 2 + floatOffsetY
    const deltaX = playerCenterX - churuCenterX
    const deltaY = playerCenterY - churuCenterY
    const distance = Math.hypot(deltaX, deltaY)

    if (!distance || distance >= CAT_RUNNING_MAGNET_RADIUS) return

    const pullDistance = Math.min(distance, CAT_RUNNING_MAGNET_PULL_SPEED * deltaSec)
    churu.x += (deltaX / distance) * pullDistance
    churu.y += (deltaY / distance) * pullDistance
  })
}

export const collectChurus = (world) => {
  const playerHitbox = getPlayerHitbox(world.player)
  let collectedCount = 0

  world.churus = world.churus.filter((churu) => {
    const isCollected = isRectOverlap(
      playerHitbox,
      getChuruHitbox({
        ...churu,
        y: churu.y + getChuruFloatOffset(churu.floatTime),
      }),
    )
    if (isCollected) {
      collectedCount += 1
    }

    return !isCollected
  })

  world.churuCount += collectedCount
}

export const updateChurus = (world, deltaSec) => {
  updateChuruPositions(world, deltaSec)
  applyMagnetToChurus(world, deltaSec)
  cleanupChurus(world)
  updateChuruSpawner(world, deltaSec)
  collectChurus(world)
}
